import { render, staticRenderFns } from "./SlsPT_Details.vue?vue&type=template&id=16739ce2"
import script from "./SlsPT_Details.vue?vue&type=script&lang=js"
export * from "./SlsPT_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports